import { createSlice } from "@reduxjs/toolkit";
import axios from "@utilities/api/httpService";
import { BASE_URL } from "../../routers/AppRoute";
import { getCatalogueMenuTree } from "@actions/catalog/getCatalogueCategoriesTree";

export const initialState = {
  loading: true,
  hasErrors: false,
  webSettings: [],
  webLinks: {}
};

// A slice for webSettings with our three reducers
const webSettingsSlice = createSlice({
  name: "webSettings",
  initialState,
  reducers: {
    getwebSettingsSuccess: (state, { payload }) => {
      state.webSettings = payload;
      state.loading = false;
      state.hasErrors = false;
    },
    getwebSettingsFailure: (state) => {
      state.loading = false;
      state.hasErrors = true;
    },
    getWebLinks: (state, { payload }) => {
      state.webLinks = payload;
    },
  },
});

// Three actions generated from the slice
export const { getwebSettingsSuccess, getwebSettingsFailure, getWebLinks} =
  webSettingsSlice.actions;

// A selector
export const webSettingsSelector = (state: any) => state?.webSettings;

// The reducer
export default webSettingsSlice.reducer;

// Asynchronous thunk action
export function fetchwebSettings(userName: string, sessionId: string) {
  return async (dispatch: any) => {
    try {
      // console.log("userName:" + userName + "sessionId:" + sessionId)
      let user =
        userName != null && userName.trim().length > 0 && userName !== undefined
          ? `?UserID=${userName}`
          : "";
      const URL = BASE_URL + `/GetWebSettings` + user;

      // const reqHeader =  `Set-Cookie:JSESSIONID=${inputQuery}`;
      const webSetting: any = await axios.get(URL);
      dispatch(getwebSettingsSuccess(webSetting?.data));
      getLoggedInUserInfo(webSetting?.data?.userCode, webSetting?.data?.languageCode);
      dispatch(
        getCatalogueMenuTree(sessionId, {
          langCode: webSetting?.data?.languageCode,
        })
      );
    } catch (error) {
      dispatch(getwebSettingsFailure());
    }
  };
}

const getLoggedInUserInfo = async (userName: string, langCode: string) => {
  try {
    const TEMPORDERDATAURL = BASE_URL + `/GetTemporaryOrderData`;
    const WEBUSERURL = BASE_URL + `/GetWebUser?UserID=${userName}`;
    const LOCALELISTURL = BASE_URL + `/GetLocaleList`;
    const MAINCATALOGUEURL =
      BASE_URL + `/GetMainCatalogue?LanguageCode=${langCode}&PageNo=1&mobile=false`;
    const HOMECATALOGUEURL =
      BASE_URL +
      `/GetHomeCatalogue?PageNo=1&NoOfItems=6&ResolutionChanged=false&LanguageCode=${langCode}`;
    await Promise.all([
      axios.get(WEBUSERURL),
      axios.get(TEMPORDERDATAURL),
      axios.get(LOCALELISTURL),
      axios.get(MAINCATALOGUEURL),
     // axios.get(HOMECATALOGUEURL),
    ]);
  } catch {
    throw Error("Promise failed");
  }
};

export function getSharedWebLinks(sessionId: any) {
  return async (dispatch: any) => {
    try {
      dispatch(getWebLinks({}));

      const URL = BASE_URL + `/GetSharedWebLinksForPages`;
      const webLinks: any = await axios.get(URL);
      dispatch(getWebLinks(webLinks.data));
      
    } catch (error) {
      console.log("Error in fetching web links", error);
    }
  }
};
